import * as React from "react";

export const NativePaper = ({ elevated = true, style, children }: { elevated?: boolean, style: React.CSSProperties, children: any }) => (
    <div className={elevated ? "theme-paper-elevated" : "theme-paper"} style={style}>
        {children}
    </div>
);




// WEBPACK FOOTER //
// ./src/components/common/NativePaper.tsx